// Deployment settings. Keep the client id and URLs in sync with src/config.py of the angelcam-actor repo.
// Client ids belong to *public* OAuth clients (no secret), so they are safe to publish.
const PRODUCTION = {
  clientId: 'ecihRwI8fEldpbt25A2aEX5FhnwRkET2s5BpNhin',
  authorizeUrl: 'https://my.angelcam.com/oauth/authorize/',
  loginUrl: 'https://my.angelcam.com/accounts/login/',
  signupUrl: 'https://my.angelcam.com/accounts/signup/',
  tokenUrl: 'https://api.angelcam.com/oauth/token/',
  redirectUri: 'https://my.angelcam.com/connect/apify/',
  applicationsUrl: 'https://my.angelcam.com/dashboard/user/applications/',
};

// TEST environment: the page served by MyAngelcam TEST. The TEST OAuth app needs both redirect URIs.
const TEST = {
  clientId: 'rRcRYGC0KumVvN3Xy3aSdyfizMy1kCptVkYEOpHX',
  authorizeUrl: 'https://my.test.angelcam.com/oauth/authorize/',
  loginUrl: 'https://my.test.angelcam.com/accounts/login/',
  signupUrl: 'https://my.test.angelcam.com/accounts/signup/',
  tokenUrl: 'https://api.test.angelcam.com/oauth/token/',
  redirectUri: 'https://my.test.angelcam.com/connect/apify/',
  applicationsUrl: 'https://my.test.angelcam.com/dashboard/user/applications/',
};

// The local dev server (dev/run.sh), signing in against TEST. Open it as localhost, not my.angelcam.dck:
// over plain HTTP, Web Crypto (PKCE) is only available on localhost.
const LOCAL = { ...TEST, redirectUri: 'http://localhost:8000/connect/apify/' };

const ENVIRONMENTS = { 'my.test.angelcam.com': TEST, localhost: LOCAL };

export const CONFIG = {
  ...(ENVIRONMENTS[globalThis.location?.hostname] ?? PRODUCTION),
  scope: 'camera_access',
  signupParams: { customer_type: 'business', primary_need: 'building_solution' },
  actorUrl: 'https://apify.com/angelcam/live-snapshot',
};
